<template>
  <div>
    <b-card header="Opciones de Filtro" class="card-filter">
      <b-btn class="filter-collapse" 
          variant="primary" 
          size="sm"
          @click.prevent="showOpcionesFiltro= !showOpcionesFiltro">
        <i :class="showOpcionesFiltro ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
      </b-btn>
      <b-collapse id="filtro" class="mt-2" v-model="showOpcionesFiltro">
        <b-form>
          <b-form-group
            label="Desde"
            label-for="fechaDesde"
            :label-cols="2"
            horizontal>
            <b-form-input 
              id="fechaDesde" 
              v-model= "filtro.fechaDesde" 
              type="date">
            </b-form-input>
          </b-form-group>

          <b-form-group
            label="Hasta"
            label-for="fechaHasta"
            :label-cols="2"
            horizontal>
            <b-form-input 
              id="fechaHasta" 
              v-model= "filtro.fechaHasta" 
              type="date">
            </b-form-input>
          </b-form-group>

          <b-form-group
            label="Cliente"
            label-for="cliente"
            :label-cols="2"
            horizontal>
            <b-input-group>
              <b-input-group-append 
                  class="filter-search-icons" 
                  @click="seleccionarCliente">
                <b-input-group-text>
                  <i :class="{ 'fa fa-search': !filtro.cliente,
                                'fa fa-remove': filtro.cliente  }"></i>
                </b-input-group-text>
              </b-input-group-append>
              <b-form-input 
                id="cliente"
                :value="clienteNombre"
                readonly
                type="text"/>
            </b-input-group>
          </b-form-group>  
        </b-form>

        <div class="footer">
          <b-button size="sm" variant="primary" class="footer-button"
            @click.prevent="filtrar">Filtrar</b-button>
          <b-button size="sm" variant="primary" class="footer-button" 
            @click.prevent="limpiarFiltro">Limpiar</b-button>
        </div>
      </b-collapse>
    </b-card>

    <b-modal ref="searchClienteModal" 
        title="Seleccionar Cliente"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="clientes-search-modal">
      <app-search-cliente
        :incluirInactivos="true"
        @clienteSeleccionado="clienteSeleccionado">
      </app-search-cliente>  
    </b-modal>
  </div>
</template>

<script>
import SearchCliente from '../clientes/SearchList.vue';
import moment from 'moment';

export default {
  components: {
    appSearchCliente: SearchCliente,
  },
  props: {
    fechaDesde: {
      type: Date,
      /*default: ''*/
    },
    fechaHasta: {
      type: Date,
      /*default: ''*/
    },
    cliente: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      filtro: {
        fechaDesde: '',
        fechaHasta: '',
        cliente: null,
      },
      showOpcionesFiltro: Boolean(false)
    }
  },
  created() {
      this.filtro.fechaDesde = moment.utc(this.fechaDesde).format('YYYY-MM-DD');
      this.filtro.fechaHasta = moment.utc(this.fechaHasta).format('YYYY-MM-DD');
      this.filtro.cliente = this.cliente;
  },
  computed: {
    'clienteNombre': function() {
      return this.filtro.cliente? this.filtro.cliente.nombre.trim() : '';
    },
  },     
  methods: {
    filtrar() {
      this.$emit('filtrar', this.filtro);
    },
    limpiarFiltro() {
      this.filtro.cliente = null;
    },
    seleccionarCliente() {
      if (this.filtro.cliente) {
        this.filtro.cliente = null;
      } else {
        this.$refs.searchClienteModal.show();
      }
    },
    clienteSeleccionado(cliente) {
      this.filtro.cliente = cliente;
      this.$refs.searchClienteModal.hide();
    },
  },
}
</script>

<style>
</style>
